import { useCallback } from "react";
import { UserService } from "services";
import UserRecommendationList from "./list";

const UserRecommendationCrmList = () => {

  const fetch = useCallback((page: number, search: string | undefined) => UserService.userRecommendationsAll({ page: page ?? 0, search: search, crm: true }), []);

  return <UserRecommendationList fetch={fetch} />;
}

export default UserRecommendationCrmList;